import SynthesisStudio from "../components/SynthesisStudio";

const Text2Speech = () => {
    return <SynthesisStudio />;
}

export default Text2Speech;